/*! For license information please see index.js.LICENSE.txt */
!function (t, e) {
  "object" == typeof exports && "object" == typeof module ? module.exports = e() : "function" == typeof define && define.amd ? define("header", [], e) : "object" == typeof exports ? exports.header = e() : t.header = e();
}(this, function () {
  return function () {
    var t = {
        48: function _(t, e, r) {
          var n = r(319).default;
          function o() {
            "use strict";

            t.exports = o = function o() {
              return r;
            }, t.exports.__esModule = !0, t.exports.default = t.exports;
            var e,
              r = {},
              i = Object.prototype,
              a = i.hasOwnProperty,
              c = Object.defineProperty || function (t, e, r) {
                t[e] = r.value;
              },
              u = "function" == typeof Symbol ? Symbol : {},
              s = u.iterator || "@@iterator",
              l = u.asyncIterator || "@@asyncIterator",
              f = u.toStringTag || "@@toStringTag";
            function p(t, e, r) {
              return Object.defineProperty(t, e, {
                value: r,
                enumerable: !0,
                configurable: !0,
                writable: !0
              }), t[e];
            }
            try {
              p({}, "");
            } catch (e) {
              p = function p(t, e, r) {
                return t[e] = r;
              };
            }
            function d(t, e, r, n) {
              var o = e && e.prototype instanceof x ? e : x,
                i = Object.create(o.prototype),
                a = new A(n || []);
              return c(i, "_invoke", {
                value: P(t, r, a)
              }), i;
            }
            function h(t, e, r) {
              try {
                return {
                  type: "normal",
                  arg: t.call(e, r)
                };
              } catch (t) {
                return {
                  type: "throw",
                  arg: t
                };
              }
            }
            r.wrap = d;
            var y = "suspendedStart",
              m = "suspendedYield",
              g = "executing",
              v = "completed",
              b = {};
            function x() {}
            function w() {}
            function O() {}
            var E = {};
            p(E, s, function () {
              return this;
            });
            var S = Object.getPrototypeOf,
              j = S && S(S(I([])));
            j && j !== i && a.call(j, s) && (E = j);
            var F = O.prototype = x.prototype = Object.create(E);
            function C(t) {
              ["next", "throw", "return"].forEach(function (e) {
                p(t, e, function (t) {
                  return this._invoke(e, t);
                });
              });
            }
            function _(t, e) {
              function r(o, i, c, u) {
                var s = h(t[o], t, i);
                if ("throw" !== s.type) {
                  var l = s.arg,
                    f = l.value;
                  return f && "object" == n(f) && a.call(f, "__await") ? e.resolve(f.__await).then(function (t) {
                    r("next", t, c, u);
                  }, function (t) {
                    r("throw", t, c, u);
                  }) : e.resolve(f).then(function (t) {
                    l.value = t, c(l);
                  }, function (t) {
                    return r("throw", t, c, u);
                  });
                }
                u(s.arg);
              }
              var o;
              c(this, "_invoke", {
                value: function value(t, n) {
                  function i() {
                    return new e(function (e, o) {
                      r(t, n, e, o);
                    });
                  }
                  return o = o ? o.then(i, i) : i();
                }
              });
            }
            function P(t, r, n) {
              var o = y;
              return function (i, a) {
                if (o === g) throw Error("Generator is already running");
                if (o === v) {
                  if ("throw" === i) throw a;
                  return {
                    value: e,
                    done: !0
                  };
                }
                for (n.method = i, n.arg = a;;) {
                  var c = n.delegate;
                  if (c) {
                    var u = T(c, n);
                    if (u) {
                      if (u === b) continue;
                      return u;
                    }
                  }
                  if ("next" === n.method) n.sent = n._sent = n.arg;else if ("throw" === n.method) {
                    if (o === y) throw o = v, n.arg;
                    n.dispatchException(n.arg);
                  } else "return" === n.method && n.abrupt("return", n.arg);
                  o = g;
                  var s = h(t, r, n);
                  if ("normal" === s.type) {
                    if (o = n.done ? v : m, s.arg === b) continue;
                    return {
                      value: s.arg,
                      done: n.done
                    };
                  }
                  "throw" === s.type && (o = v, n.method = "throw", n.arg = s.arg);
                }
              };
            }
            function T(t, r) {
              var n = r.method,
                o = t.iterator[n];
              if (o === e) return r.delegate = null, "throw" === n && t.iterator.return && (r.method = "return", r.arg = e, T(t, r), "throw" === r.method) || "return" !== n && (r.method = "throw", r.arg = new TypeError("The iterator does not provide a '" + n + "' method")), b;
              var i = h(o, t.iterator, r.arg);
              if ("throw" === i.type) return r.method = "throw", r.arg = i.arg, r.delegate = null, b;
              var a = i.arg;
              return a ? a.done ? (r[t.resultName] = a.value, r.next = t.nextLoc, "return" !== r.method && (r.method = "next", r.arg = e), r.delegate = null, b) : a : (r.method = "throw", r.arg = new TypeError("iterator result is not an object"), r.delegate = null, b);
            }
            function k(t) {
              var e = {
                tryLoc: t[0]
              };
              1 in t && (e.catchLoc = t[1]), 2 in t && (e.finallyLoc = t[2], e.afterLoc = t[3]), this.tryEntries.push(e);
            }
            function L(t) {
              var e = t.completion || {};
              e.type = "normal", delete e.arg, t.completion = e;
            }
            function A(t) {
              this.tryEntries = [{
                tryLoc: "root"
              }], t.forEach(k, this), this.reset(!0);
            }
            function I(t) {
              if (t || "" === t) {
                var r = t[s];
                if (r) return r.call(t);
                if ("function" == typeof t.next) return t;
                if (!isNaN(t.length)) {
                  var o = -1,
                    i = function r() {
                      for (; ++o < t.length;) if (a.call(t, o)) return r.value = t[o], r.done = !1, r;
                      return r.value = e, r.done = !0, r;
                    };
                  return i.next = i;
                }
              }
              throw new TypeError(n(t) + " is not iterable");
            }
            return w.prototype = O, c(F, "constructor", {
              value: O,
              configurable: !0
            }), c(O, "constructor", {
              value: w,
              configurable: !0
            }), w.displayName = p(O, f, "GeneratorFunction"), r.isGeneratorFunction = function (t) {
              var e = "function" == typeof t && t.constructor;
              return !!e && (e === w || "GeneratorFunction" === (e.displayName || e.name));
            }, r.mark = function (t) {
              return Object.setPrototypeOf ? Object.setPrototypeOf(t, O) : (t.__proto__ = O, p(t, f, "GeneratorFunction")), t.prototype = Object.create(F), t;
            }, r.awrap = function (t) {
              return {
                __await: t
              };
            }, C(_.prototype), p(_.prototype, l, function () {
              return this;
            }), r.AsyncIterator = _, r.async = function (t, e, n, o, i) {
              void 0 === i && (i = Promise);
              var a = new _(d(t, e, n, o), i);
              return r.isGeneratorFunction(e) ? a : a.next().then(function (t) {
                return t.done ? t.value : a.next();
              });
            }, C(F), p(F, f, "Generator"), p(F, s, function () {
              return this;
            }), p(F, "toString", function () {
              return "[object Generator]";
            }), r.keys = function (t) {
              var e = Object(t),
                r = [];
              for (var n in e) r.push(n);
              return r.reverse(), function t() {
                for (; r.length;) {
                  var n = r.pop();
                  if (n in e) return t.value = n, t.done = !1, t;
                }
                return t.done = !0, t;
              };
            }, r.values = I, A.prototype = {
              constructor: A,
              reset: function reset(t) {
                if (this.prev = 0, this.next = 0, this.sent = this._sent = e, this.done = !1, this.delegate = null, this.method = "next", this.arg = e, this.tryEntries.forEach(L), !t) for (var r in this) "t" === r.charAt(0) && a.call(this, r) && !isNaN(+r.slice(1)) && (this[r] = e);
              },
              stop: function stop() {
                this.done = !0;
                var t = this.tryEntries[0].completion;
                if ("throw" === t.type) throw t.arg;
                return this.rval;
              },
              dispatchException: function dispatchException(t) {
                if (this.done) throw t;
                var r = this;
                function n(n, o) {
                  return c.type = "throw", c.arg = t, r.next = n, o && (r.method = "next", r.arg = e), !!o;
                }
                for (var o = this.tryEntries.length - 1; o >= 0; --o) {
                  var i = this.tryEntries[o],
                    c = i.completion;
                  if ("root" === i.tryLoc) return n("end");
                  if (i.tryLoc <= this.prev) {
                    var u = a.call(i, "catchLoc"),
                      s = a.call(i, "finallyLoc");
                    if (u && s) {
                      if (this.prev < i.catchLoc) return n(i.catchLoc, !0);
                      if (this.prev < i.finallyLoc) return n(i.finallyLoc);
                    } else if (u) {
                      if (this.prev < i.catchLoc) return n(i.catchLoc, !0);
                    } else {
                      if (!s) throw Error("try statement without catch or finally");
                      if (this.prev < i.finallyLoc) return n(i.finallyLoc);
                    }
                  }
                }
              },
              abrupt: function abrupt(t, e) {
                for (var r = this.tryEntries.length - 1; r >= 0; --r) {
                  var n = this.tryEntries[r];
                  if (n.tryLoc <= this.prev && a.call(n, "finallyLoc") && this.prev < n.finallyLoc) {
                    var o = n;
                    break;
                  }
                }
                o && ("break" === t || "continue" === t) && o.tryLoc <= e && e <= o.finallyLoc && (o = null);
                var i = o ? o.completion : {};
                return i.type = t, i.arg = e, o ? (this.method = "next", this.next = o.finallyLoc, b) : this.complete(i);
              },
              complete: function complete(t, e) {
                if ("throw" === t.type) throw t.arg;
                return "break" === t.type || "continue" === t.type ? this.next = t.arg : "return" === t.type ? (this.rval = this.arg = t.arg, this.method = "return", this.next = "end") : "normal" === t.type && e && (this.next = e), b;
              },
              finish: function finish(t) {
                for (var e = this.tryEntries.length - 1; e >= 0; --e) {
                  var r = this.tryEntries[e];
                  if (r.finallyLoc === t) return this.complete(r.completion, r.afterLoc), L(r), b;
                }
              },
              catch: function _catch(t) {
                for (var e = this.tryEntries.length - 1; e >= 0; --e) {
                  var r = this.tryEntries[e];
                  if (r.tryLoc === t) {
                    var n = r.completion;
                    if ("throw" === n.type) {
                      var o = n.arg;
                      L(r);
                    }
                    return o;
                  }
                }
                throw Error("illegal catch attempt");
              },
              delegateYield: function delegateYield(t, r, n) {
                return this.delegate = {
                  iterator: I(t),
                  resultName: r,
                  nextLoc: n
                }, "next" === this.method && (this.arg = e), b;
              }
            }, r;
          }
          t.exports = o, t.exports.__esModule = !0, t.exports.default = t.exports;
        },
        319: function _(t) {
          function e(r) {
            return t.exports = e = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (t) {
              return typeof t;
            } : function (t) {
              return t && "function" == typeof Symbol && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
            }, t.exports.__esModule = !0, t.exports.default = t.exports, e(r);
          }
          t.exports = e, t.exports.__esModule = !0, t.exports.default = t.exports;
        },
        799: function _(t, e, r) {
          var n = r(48)();
          t.exports = n;
          try {
            regeneratorRuntime = n;
          } catch (t) {
            "object" == typeof globalThis ? globalThis.regeneratorRuntime = n : Function("r", "regeneratorRuntime = r")(n);
          }
        }
      },
      e = {};
    function r(n) {
      var o = e[n];
      if (void 0 !== o) return o.exports;
      var i = e[n] = {
        exports: {}
      };
      return t[n](i, i.exports, r), i.exports;
    }
    r.d = function (t, e) {
      for (var n in e) r.o(e, n) && !r.o(t, n) && Object.defineProperty(t, n, {
        enumerable: !0,
        get: e[n]
      });
    }, r.g = function () {
      if ("object" == typeof globalThis) return globalThis;
      try {
        return this || new Function("return this")();
      } catch (t) {
        if ("object" == typeof window) return window;
      }
    }(), r.o = function (t, e) {
      return Object.prototype.hasOwnProperty.call(t, e);
    };
    var n = {};
    return function () {
      "use strict";

      function t(e) {
        return t = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (t) {
          return typeof t;
        } : function (t) {
          return t && "function" == typeof Symbol && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
        }, t(e);
      }
      function e(e, r, n) {
        return (r = function (e) {
          var r = function (e, r) {
            if ("object" != t(e) || !e) return e;
            var n = e[Symbol.toPrimitive];
            if (void 0 !== n) {
              var o = n.call(e, "string");
              if ("object" != t(o)) return o;
              throw new TypeError("@@toPrimitive must return a primitive value.");
            }
            return String(e);
          }(e);
          return "symbol" == t(r) ? r : r + "";
        }(r)) in e ? Object.defineProperty(e, r, {
          value: n,
          enumerable: !0,
          configurable: !0,
          writable: !0
        }) : e[r] = n, e;
      }
      r.d(n, {
        default: function _default() {
          return W;
        }
      }), r(799);
      var o = "undefined" != typeof window;
      var i = "awefewfuihewfhewfuhiebc",
        a = "limitedConsent",
        c = "enct-",
        u = "essential",
        s = "GI",
        l = "IGO",
        f = "HDFC_SB",
        p = "AFFCGOBIZMMTAIX",
        d = (e(e(e({}, s, {
          colors: {
            base: {
              primary: "#016eff"
            },
            button: {
              primary: {
                bg: "linear-gradient(93deg, #FF6D38, #FF6D38)",
                text: "#FFFFFF"
              }
            }
          },
          style: {
            button: {
              borderRadius: "8px"
            }
          },
          font: {
            urls: ["https://fonts.googleapis.com/css?family=Quicksand:300,400,400i,700,900&display=swap"],
            family: "'Quicksand', sans-serif",
            familyHeading: "'Quicksand', sans-serif"
          }
        }), l, {
          colors: {
            base: {
              primary: "#00228E"
            },
            button: {
              primary: {
                bg: "linear-gradient(93deg, #00228E, #00228E)",
                text: "#FFFFFF"
              }
            }
          },
          style: {
            button: {
              borderRadius: "8px"
            }
          },
          font: {
            urls: ["https://fonts.googleapis.com/css?family=Lato:300,400,400i,700,900&display=swap", "https://db.onlinewebfonts.com/c/390289fedd068780e28c0f9f259c3782?family=ITC+Bauhaus"],
            family: "'Lato'",
            familyHeading: "'ITC Bauhaus'"
          }
        }), p, {
          colors: {
            base: {
              primary: "#FF6423"
            },
            button: {
              primary: {
                bg: "linear-gradient(93deg, #FF6D38, #FF6D38)",
                text: "#FFFFFF"
              }
            }
          },
          style: {
            button: {
              borderRadius: "8px"
            }
          },
          font: {
            urls: ["https://fonts.googleapis.com/css?family=Lato:300,400,400i,700,900&display=swap", "https://db.onlinewebfonts.com/c/390289fedd068780e28c0f9f259c3782?family=ITC+Bauhaus"],
            family: "'Lato'",
            familyHeading: "'ITC Bauhaus'"
          }
        }), e(e({}, s, {
          ACCOUNTS_TERMS_CONDITION: "https://giholidays.makemytrip.com/legal/gi/user_agreement.html",
          ACCOUNTS_PRIVACY_URL: "https://giholidays.makemytrip.com/legal/gi/privacy_policy.html",
          TERMS_OF_SERVICE: "https://giholidays.makemytrip.com/legal/gi/user_agreement.html#tos"
        }), l, {
          ACCOUNTS_TERMS_CONDITION: "https://6eholidays.makemytrip.com/legal/igo/user_agreement.html",
          ACCOUNTS_PRIVACY_URL: "https://6eholidays.makemytrip.com/legal/igo/privacy_policy.html",
          TERMS_OF_SERVICE: "https://6eholidays.makemytrip.com/legal/igo/user_agreement.html#tos"
        }), function (t) {
          var e,
            r = t || "";
          o && (r = (null === (e = window) || void 0 === e || null === (e = e.location) || void 0 === e ? void 0 : e.hostname) || "");
          var n = "";
          return r && (-1 !== r.indexOf("giholidays") ? n = s : -1 !== r.indexOf("6eholidays") ? n = l : -1 !== r.indexOf("hdfcsmartbuyholidays") ? n = f : -1 !== r.indexOf("airindiaexpressholidays") ? n = p : -1 !== r.indexOf("flightsexpert.goibibo") ? n = "AFFCGOBIZGIFLTEXP" : -1 !== r.indexOf("flightsexpert.makemytrip") || -1 !== r.indexOf("holidaysexpert.makemytrip") ? n = "AFFCGOBIZMMTFLTEXP" : -1 !== r.indexOf("forexexpert.makemytrip") ? n = "AFFTMFXMMTFOREXEXP" : -1 !== r.indexOf("forexexpert.goibibo") && (n = "AFFTMFXGIFOREXEXP")), n;
        }),
        h = function h(t, e) {
          var r = d(e).toLowerCase();
          return r ? "".concat(t, "-").concat(r) : t;
        },
        y = {},
        m = function m(t, e, r, n) {
          var i,
            a,
            c = r,
            s = n,
            l = (null == y ? void 0 : y[t]) || {};
          return o && (c = void 0 === r ? (null === (i = l[e]) || void 0 === i ? void 0 : i.type) || "nonEssential" : r, s = void 0 === n ? (null === (a = l[e]) || void 0 === a ? void 0 : a.isPiiData) || !1 : n), {
            essential: c = c === u,
            piiData: s
          };
        },
        g = function g(t) {
          return new RegExp("(?:^|;\\s*)".concat(t, "\\s*=\\s*([^;]*)"));
        },
        v = function v(t) {
          var e = h(t),
            r = g(e).exec(document.cookie);
          return null !== r ? decodeURIComponent(r[1]) : null;
        },
        b = function b() {
          var t, e, r, n;
          return "1" !== v("isGdprRegion") || (t = v("myBusinessSubscription"), r = null == (e = v("mmt-auth")) ? void 0 : e.charAt(e.length - 1), !!(t && "b2b" === t || "C" === r) || (!(n = v("GDPR_C")) || "IS" !== n && "11" !== n ? "fullConsent" : a) !== a);
        },
        x = "cookieList",
        w = function w(t) {
          return new TypeError("Valid key & value is required for @MMT-UI/storages$$/client/cookies ".concat(t));
        },
        O = function O(t) {
          var e = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {},
            r = arguments.length > 2 ? arguments[2] : void 0;
          try {
            var n;
            if (!o) return null;
            if (!t) throw w("get");
            var a,
              u = (e || {}).isPiiData,
              s = (e || {}).shouldParseJson,
              l = m(x, t, r, u);
            if (a = l.essential, u = l.piiData, !a && !b()) return null;
            var f = g(t).exec(document.cookie),
              p = null !== f ? decodeURIComponent(f[1]) : null;
            if (u && null !== (n = p) && void 0 !== n && n.includes(c)) {
              var d = new RegExp("^".concat(c));
              p = function (t, e) {
                try {
                  var r = "",
                    n = 0;
                  if (!e) throw new Error("Key is empty");
                  for (var o = 0; o < t.length; o += 1) {
                    var i = t.charCodeAt(o) ^ e.charCodeAt(n);
                    r += String.fromCharCode(i), n = (n + 1) % e.length;
                  }
                  return r;
                } catch (t) {
                  return console.error("An error occurred during the decryption process:", t), null;
                }
              }(p = p.replace(d, ""), i);
            }
            return s && (p = function (t) {
              try {
                return JSON.parse(t);
              } catch (t) {
                return null;
              }
            }(p)), p;
          } catch (t) {
            return null;
          }
        },
        E = (new Date(), function () {
          return o && d() ? ".".concat(window.location.hostname) : ".makemytrip.com";
        }),
        S = function S() {
          var e,
            r,
            n,
            a,
            s = O(h("dvid"), void 0, u) || (e = new Date().getTime(), "undefined" != typeof performance && "function" == typeof performance.now && (e += performance.now()), "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(/[xy]/g, function (t) {
              var r = (e + 16 * Math.random()) % 16 | 0;
              return e = Math.floor(e / 16), ("x" === t ? r : 3 & r | 8).toString(16);
            }));
          return r = s, !O(h("dvid"), void 0, u) && r && function (e, r, n, a) {
            try {
              if (!o) return !1;
              if (!e || void 0 === r) throw w("set");
              var u,
                s = n || {},
                l = s.expiresVal,
                f = s.maxAge,
                p = s.path,
                d = s.domain,
                h = s.secure,
                y = s.sameSite,
                g = s.shouldStringifyJson,
                v = s.partitioned,
                O = (n || {}).isPiiData,
                E = m(x, e, a, O);
              if (u = E.essential, O = E.piiData, !u && !b()) return !1;
              var S = g ? function (t) {
                try {
                  return JSON.stringify(t);
                } catch (t) {
                  return null;
                }
              }(r) : r;
              if (S && O) {
                var j = function (t, e) {
                  try {
                    var r = "",
                      n = 0;
                    if (!e) throw new Error("Key is empty");
                    for (var o = 0; o < t.length; o += 1) {
                      var i = t.charCodeAt(o) ^ e.charCodeAt(n);
                      r += String.fromCharCode(i), n = (n + 1) % e.length;
                    }
                    return r;
                  } catch (t) {
                    return console.error("An error occurred during encryption:", t), null;
                  }
                }(S, i);
                if (!j) return !1;
                S = "".concat(c).concat(j);
              }
              var C = function (e, r) {
                  var n = e ? "; max-age=".concat(e) : "",
                    o = "";
                  if (r) switch (t(r)) {
                    case "string":
                      o = "; expires=".concat(new Date(r).toUTCString());
                      break;
                    case "number":
                      var i = new Date();
                      i.setSeconds(r), o = "; expires=".concat(i.toUTCString());
                      break;
                    case "object":
                      r instanceof Date && (o = "; expires=".concat(r.toUTCString()));
                  }
                  return {
                    sMaxAge: n,
                    sExpiry: o
                  };
                }(f, l),
                _ = C.sMaxAge,
                P = C.sExpiry,
                T = v || F() ? "; samesite=none; secure; partitioned" : "";
              T || (T = h ? y ? "; samesite=".concat(y, "; secure") : "; secure" : y ? "; samesite=".concat(y) : "");
              var k = "".concat(encodeURIComponent(e), "=").concat(encodeURIComponent(S)),
                L = "".concat(_).concat(P).concat(p ? "; path=".concat(p) : ""),
                A = "".concat(d ? "; domain=".concat(d) : "").concat(T);
              return document.cookie = "".concat(k).concat(L).concat(A), !0;
            } catch (t) {
              return !1;
            }
          }(h("dvid"), r, {
            expiresVal: (n = new Date(), a = n.getTime(), a += 305856e5, n.setTime(a), n),
            path: "/",
            domain: E()
          }, u), s;
        },
        j = function j() {
          return O(h("mmt-auth"), void 0, u);
        },
        F = function F() {
          return false;
        },
        C = "//www.makemytrip.com",
        _ = (e({}, "accountLinked", {
          title: {
            id: "login.widget.pwa.account.linked.successfully",
            defaultMessage: "Account linked Successfully"
          }
        }), "//mapi.makemytrip.com"),
        P = "".concat(_, "/ext/web/pwa"),
        T = ("".concat(_, "/ext/hcs"), "".concat(_, "/surveymgmt/v1/commonnps/createDesktopSurvey"), "x-gommt-client-id"),
        k = "IN",
        L = "eng",
        A = {
          IN: "in",
          AE: "ae",
          US: "us",
          OM: "om",
          SA: "sa",
          KW: "kw"
        },
        I = {
          IN: L,
          AE: L,
          US: L,
          OM: L,
          SA: L,
          KW: L
        },
        D = {
          IN: "inr",
          AE: "aed",
          US: "usd",
          SA: "sar",
          KW: "kwd",
          OM: "omr"
        },
        R = {},
        M = function M() {
          return R.countryCode ? R : {
            countryCode: A[k],
            language: I[k],
            currency: D[k]
          };
        },
        N = {},
        G = function G() {
          return (null == N ? void 0 : N.languageCode) || L;
        },
        U = function U() {
          return M().currency;
        },
        B = function B() {
          return M().countryCode;
        },
        X = ("".concat(C, "/legal/").concat(B(), "/").concat(G(), "/user_agreement.html"), "".concat(C, "/legal/").concat(B(), "/").concat(G(), "/privacy_policy.html"), "".concat(C, "/legal/").concat(B(), "/").concat(G(), "/user_agreement.html#tos"), function () {
          return O("userCurrency", void 0, u);
        }),
        V = ["headers", "body"];
      function J(t, e) {
        var r = Object.keys(t);
        if (Object.getOwnPropertySymbols) {
          var n = Object.getOwnPropertySymbols(t);
          e && (n = n.filter(function (e) {
            return Object.getOwnPropertyDescriptor(t, e).enumerable;
          })), r.push.apply(r, n);
        }
        return r;
      }
      function K(t) {
        for (var r = 1; r < arguments.length; r++) {
          var n = null != arguments[r] ? arguments[r] : {};
          r % 2 ? J(Object(n), !0).forEach(function (r) {
            e(t, r, n[r]);
          }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(t, Object.getOwnPropertyDescriptors(n)) : J(Object(n)).forEach(function (e) {
            Object.defineProperty(t, e, Object.getOwnPropertyDescriptor(n, e));
          });
        }
        return t;
      }
      var H = {
          "Content-Type": "application/json",
          deviceid: S(),
          "Request-Data-Encoding": "json",
          Accept: "*/*"
        },
        Y = {
          message: "Incorrect request body"
        };
      function q(t, e) {
        var r = Object.keys(t);
        if (Object.getOwnPropertySymbols) {
          var n = Object.getOwnPropertySymbols(t);
          e && (n = n.filter(function (e) {
            return Object.getOwnPropertyDescriptor(t, e).enumerable;
          })), r.push.apply(r, n);
        }
        return r;
      }
      function Q(t) {
        for (var r = 1; r < arguments.length; r++) {
          var n = null != arguments[r] ? arguments[r] : {};
          r % 2 ? q(Object(n), !0).forEach(function (r) {
            e(t, r, n[r]);
          }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(t, Object.getOwnPropertyDescriptors(n)) : q(Object(n)).forEach(function (e) {
            Object.defineProperty(t, e, Object.getOwnPropertyDescriptor(n, e));
          });
        }
        return t;
      }
      var W = function W(t) {
        if (Array.isArray(t)) {
          var e = [];
          return t.forEach(function (t) {
            var r = t || {},
              n = r.column,
              o = r.searchContext;
            n && o && e.push({
              column: n,
              datasetName: "recent_searches_test",
              value: {
                searchContext: o
              }
            });
          }), (null == e ? void 0 : e.length) > 0 ? function (t) {
            var e,
              r,
              n,
              o,
              i,
              a = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {},
              c = a.headers,
              u = void 0 === c ? {} : c,
              s = a.body,
              l = function (t, e) {
                if (null == t) return {};
                var r,
                  n,
                  o = function (t, e) {
                    if (null == t) return {};
                    var r = {};
                    for (var n in t) if ({}.hasOwnProperty.call(t, n)) {
                      if (e.includes(n)) continue;
                      r[n] = t[n];
                    }
                    return r;
                  }(t, e);
                if (Object.getOwnPropertySymbols) {
                  var i = Object.getOwnPropertySymbols(t);
                  for (n = 0; n < i.length; n++) r = i[n], e.includes(r) || {}.propertyIsEnumerable.call(t, r) && (o[r] = t[r]);
                }
                return o;
              }(a, V),
              p = arguments.length > 2 ? arguments[2] : void 0,
              d = arguments.length > 3 ? arguments[3] : void 0,
              h = (arguments.length > 4 ? arguments[4] : void 0) ? t : function (t) {
                var e = "region=".concat(B(), "&language=").concat(G(), "&currency=").concat(U());
                return -1 !== t.indexOf("?") ? "".concat(t, "&").concat(e) : "".concat(t, "?").concat(e);
              }(t),
              y = K({
                headers: K(p ? {} : K({}, (n = S(), o = {
                  "Content-Type": "application/json",
                  vid: n,
                  tid: n,
                  "usr-mcid": n,
                  deviceid: n,
                  Authorization: "h4nhc9jcgpAGIjp",
                  Accept: "application/json",
                  "visitor-id": n,
                  region: B(),
                  language: G(),
                  currency: U(),
                  "user-currency": X()
                }, i = j(), i && (o = K(K({}, o), {}, {
                  "mmt-auth": i
                })), o)), u),
                body: d ? s : JSON.stringify(s)
              }, l);
            return null !== (e = y) && void 0 !== e && null !== (e = e.headers) && void 0 !== e && e[T] && (null === (r = y) || void 0 === r || null === (r = r.headers) || void 0 === r ? void 0 : r[T]) !== f || delete y.headers[T], function (t) {
              return t.includes(P);
            }(t) && (y = K(K({}, y), {}, {
              credentials: "include"
            })), fetch(h, y).then(function (t) {
              var e = null == t ? void 0 : t.json();
              return (null == t ? void 0 : t.status) >= 200 && (null == t ? void 0 : t.status) < 300 ? e : null == e ? void 0 : e.then(function (e) {
                throw {
                  body: e,
                  status: t.status
                };
              });
            });
          }("//pdt.makemytrip.com/fs/w", {
            headers: (r = H, n = j(), n && (r = Q(Q({}, r), {}, {
              "mmt-auth": n
            })), r),
            method: "POST",
            body: e
          }, !0, void 0, !0) : Y;
        }
        var r, n;
        return Y;
      };
    }(), n.default;
  }();
});